import { USER_ACTIONS_TYPES, UserState, UserActions } from './types'

function setData(payload: Partial<UserState>): UserActions {
  return {
    type: USER_ACTIONS_TYPES.USER_SET_DATA,
    payload,
  }
}

function resetData(): UserActions {
  return {
    type: USER_ACTIONS_TYPES.USER_RESET_DATA,
  }
}

export default {
  setData,
  resetData,
}
